export default __webpack_public_path__ + "static/media/close-modal-icon.03f6090a.svg";